import React, { useMemo } from 'react';
import clsx from 'clsx';
import { StatusCodes } from 'http-status-codes';
import { toast } from 'react-toastify';
import GhostButton from '../GhostButton/GhostButton';
import StyledTableBodyRow from './TableBodyRowOrderAdmin.styles';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg';
import { ReactComponent as RerunIcon } from '../../assets/icons/refresh.svg';
import { ReactComponent as CreditCardIcon } from '../../assets/icons/credit-card.svg';
// import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg';
import type { DownloadAdminOrderRequestType, OrderType, UploadAdminOrderRequestType, FileRerunRequestType } from '../../types/orderTypes';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import orderThunk from '../../store/order/orderThunk';
import { convertFileToBase64 } from '../../utils/convertFileHelper';
import { orderAPI } from '../../api/services/orderApi';
import { formattingDate } from '../../utils/formattingDateHelper';
import type { UserType } from '../../types/userTypes';
import { checkIsSuccessfulErrorMessage } from '../../utils/errorCheckHelper';

type PropsType = {
  item: OrderType;
  className?: string;
  user: UserType;
  onViewTransactions?: (order: OrderType) => void;
};

const TableBodyRowOrderAdmin: React.FC<PropsType> = (props) => {
  const { item, className = '', user, onViewTransactions } = props;
  const dispatch = useAppDispatch();
  const filter = useAppSelector((state) => state.orderSlice.filter);
  const currentStatusClassName = (status: string) => `${status.split(' ').join('-').toLowerCase()}-status`;
  const correctDisplayInfo = (info: number | string | null) => (info || '-');
  const isSuccessStatus = checkIsSuccessfulErrorMessage(item.status);
  const hasTransactions = (item.transactions?.length ?? 0) > 0;
  // const onClickProcess = async (
  //   item: OrderType, e: React.MouseEvent<HTMLDivElement>,
  // ) => {
  //   e.preventDefault();
  //   try {
  //     await orderAPI.processOutputFileSFTP(item.userFileId);
  //     toast.success('Skip Ready successfully scheduled.');
  //     await dispatch(orderThunk.getAdminOrders(filter)).unwrap();
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // };

  const onClickDownloadOuput = async (
    item: { nameFileAdmin: string | null; userId: number }, e: React.MouseEvent<HTMLDivElement>,
  ) => {
    let nameFileAdmin = '';
    e.preventDefault();
    try {
      if (item.nameFileAdmin) {
        nameFileAdmin = item.nameFileAdmin;
        const fileInfo: DownloadAdminOrderRequestType = {
          name: nameFileAdmin,
          userId: item.userId,
        };

        const res = await orderAPI.downloadOutputAdminFile(fileInfo);
        if (res.status === StatusCodes.OK) {
          const link = document.createElement('a');
          link.href = res.data.data.file;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        await dispatch(orderThunk.getAdminOrders(filter)).unwrap();
      } else {
        toast.error('Skip Ready file is not available yet.');
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const onClickRerun = async (
    item: OrderType, e: React.MouseEvent<HTMLDivElement>,
  ) => {
    e.preventDefault();
    try {
      const fileInfo: FileRerunRequestType = {
        userFileId: item.userFileId,
        email: item.user?.email,
      };
      const res = await orderAPI.rerunOrderFileAdmin(fileInfo);
      if (res.status === StatusCodes.OK) {
        toast.success('File re-run successfully scheduled.');
      }
      await dispatch(orderThunk.getAdminOrders(filter)).unwrap();
    } catch (error) {
      toast.error(error);
    }
  };

  const onClickDownloadInput = async (
    item: OrderType, e: React.MouseEvent<HTMLDivElement>,
  ) => {
    e.preventDefault();
    try {
      const fileInfo: DownloadAdminOrderRequestType = {
        name: item.name,
        userId: item.user?.userId,
      };

      const res = await orderAPI.downloadInputAdminFile(fileInfo);
      if (res.status === StatusCodes.OK) {
        const link = document.createElement('a');
        link.href = res.data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      await dispatch(orderThunk.getAdminOrders(filter)).unwrap();
    } catch (error) {
      toast.error(error);
    }
  };

  const onClickUpload = async (
    item: OrderType,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    e.preventDefault();
    try {
      if (e.target.files && e.target.files[0]) {
        const currentFile = e.target.files[0];
        if (currentFile.name.endsWith('.csv')) {
          const fileInfo: UploadAdminOrderRequestType = {
            userId: item.user?.userId,
            originFileName: item.name,
            fileName: currentFile.name,
            file: '',
          };
          const convertedFile = await convertFileToBase64(currentFile);
          fileInfo.file = convertedFile.split('base64,')[1];
          await dispatch(orderThunk.uploadAdminFile(fileInfo)).unwrap();
          await dispatch(orderThunk.getAdminOrders(filter)).unwrap();
          toast.success('The file has been uploaded');
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getHitRate = (successfullRecords: number, totalRecords: number) => {
    if (totalRecords === 0) {
      return 0;
    }
    return ((successfullRecords / totalRecords) * 100).toFixed(2);
  };

  const orderValueArray = useMemo(() => {
    const transactionsButton = hasTransactions && onViewTransactions ? (
      <GhostButton className="secondary">
        <div
          onClick={(e) => {
            e.preventDefault();
            onViewTransactions(item);
          }}
          title="View transactions"
        >
          <CreditCardIcon />
        </div>
      </GhostButton>
    ) : null;

    let object = {
      content: (
        <UploadIcon />
      ),
    };
    if (user?.email.toLocaleLowerCase() === 'andreremigiobr@gmail.com') {
      object = {
        content: (
          <div>
            <GhostButton className="secondary">
              <label id="label-file-upload" htmlFor={`input-file-upload-${item.userFileId}`}>
                <input
                  type="file"
                  id={`input-file-upload-${item.userFileId}`}
                  onChange={(e) => onClickUpload(item, e)}
                  accept=".csv"
                />
                <UploadIcon />
              </label>
            </GhostButton>
            {/* <GhostButton className="secondary">
                <div onClick={(e) => onClickProcess(item, e)}>
                  <RefreshIcon />
                </div>
            </GhostButton> */}
            {transactionsButton}
          </div>
        ),
      };
    } else {
      object = {
        content: (
          <div>
            <GhostButton className="secondary">
              <label id="label-file-upload" htmlFor={`input-file-upload-${item.userFileId}`}>
                <input
                  type="file"
                  id={`input-file-upload-${item.userFileId}`}
                  onChange={(e) => onClickUpload(item, e)}
                  accept=".csv"
                />
                <UploadIcon />
              </label>
            </GhostButton>
            <GhostButton className="secondary">
              <div onClick={(e) => onClickRerun(item, e)}>
                <RerunIcon />
              </div>
            </GhostButton>
            {transactionsButton}
          </div>
        ),
      };
    }
    return [
      { content: item.userFileId },

      {
        content: item.name,
        type: 'p',
      },

      {
        content: item.totalRecords,
      },

      {
        content: item.successfullRecords,
      },

      {
        content: `${getHitRate(item.successfullRecords, item.totalRecords)}%`,
      },
      { content: item.campaignDuplicates },

      { content: formattingDate(item.createdAt) },

      { content: correctDisplayInfo(item?.user?.fullName) },

      { content: item.user?.email },

      { content: item.type },

      { content: item.metadata.email ? 'Yes' : 'No' },

      { content: item.metadata.blacklist ? 'Yes' : 'No' },

      { content: item.metadata.dnc ? 'Yes' : 'No' },

      { content: `$${item.price.toFixed(2)}` },

      {
        content: item.status,
        type: 'div',
        className: clsx(['order-status', currentStatusClassName(item.status)]),
      },

      // { content: correctDisplayInfo(item.notes) },

      {
        content: (
          <div>
            <GhostButton
              disabled={!isSuccessStatus}
            >
              <div
                onClick={(e) => onClickDownloadInput(item, e)}
              >
                <DownloadIcon />
                <p className="text-3">Input</p>
              </div>
            </GhostButton>
            <GhostButton
              disabled={!isSuccessStatus}
            >
              <div
                onClick={(e) => onClickDownloadOuput(
                  { nameFileAdmin: item.nameFileAdmin, userId: item.user.userId },
                  e,
                )}
              >
                <DownloadIcon />
                <p className="text-3">Output</p>
              </div>
            </GhostButton>
            <GhostButton
              disabled={!isSuccessStatus}
            >
              <div
                onClick={(e) => onClickDownloadOuput(
                  {
                    nameFileAdmin: item?.nameFileAdmin?.replace('O.csv', 'CO.csv') ?? '',
                    userId: item.user.userId,
                  },
                  e,
                )}
              >
                <DownloadIcon />
                <p className="text-3">Full Export</p>
              </div>
            </GhostButton>
          </div>
        ),
      },

      object,
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, hasTransactions, onViewTransactions]);

  return (
    <StyledTableBodyRow className={className}>

      {orderValueArray.map((rowItem, index) => {
        if (rowItem.type === 'p') {
          return (
            <td key={index}>
              <p className="styled-table-row__text">{rowItem.content}</p>
            </td>
          );
        }
        if (rowItem.type === 'div') {
          return (
            <td key={index}>
              <div className={clsx(rowItem.className)}>{rowItem.content}</div>
            </td>
          );
        }
        return (
          <td key={index}>
            <div>
              {rowItem.content}
            </div>
          </td>
        );
      })}
    </StyledTableBodyRow>
  );
};

export default TableBodyRowOrderAdmin;
